'use client'

import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { heightDesktopVar, heightVar, iframe, widthDesktopVar, widthVar } from './IframeBlock.css'

type IframeBlockProps = SbBaseBlockProps<{
  url: { url: string }
  title?: string
  width: string
  height: string
  widthDesktop?: string
  heightDesktop?: string
}>

export function IframeBlock({ blok }: IframeBlockProps) {
  return (
    <iframe
      src={blok.url.url}
      title={blok.title?.trim()}
      className={iframe}
      style={assignInlineVars({
        [widthVar]: toCssValue(blok.width),
        [heightVar]: toCssValue(blok.height),
        [widthDesktopVar]: toCssValue(blok.widthDesktop || blok.width),
        [heightDesktopVar]: toCssValue(blok.heightDesktop || blok.height),
      })}
      referrerPolicy="no-referrer-when-downgrade"
    />
  )
}

function toCssValue(value: string) {
  // If it's just a number, add 'px'
  return /^\d+$/.test(value) ? `${value}px` : value
}
